import "../css/header.css";
const Header = () => {
  return (
    <div className="header">
      <img src="/images/logo.png" alt="" />
    </div>
  );
};

export default Header;
